import * as actionTypes from './actionTypes';
import * as actions from './index';

export const loadVimeoVideos = () => {
    return dispatch => {
        dispatch({ type: actionTypes.VIMEO_LOAD_START });

        window.flow.vimeoMyVideos().then(res => {
            dispatch({ type: actionTypes.VIMEO_LOAD_SUCCESS, videos: res});
        }).catch(res => {
            dispatch({ type: actionTypes.VIMEO_LOAD_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const uploadVimeoVideos = (id, title) => {
    return dispatch => {
        dispatch({ type: actionTypes.VIMEO_UPLOAD_START });

        window.flow.vimeoUploadVideo({"clid":id,"title":title,"description":""}).then(res => {
            dispatch({ type: actionTypes.VIMEO_UPLOAD_SUCCESS});
            dispatch(actions.loadVimeoVideos());
        }).catch(res => {
            dispatch({ type: actionTypes.VIMEO_UPLOAD_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const deleteVimeoVideos = (id) => {
    return dispatch => {
        dispatch({ type: actionTypes.VIMEO_DELETE_START });

        window.flow.vimeoDeleteVideo({"id": id}).then(res => {
            dispatch({ type: actionTypes.VIMEO_DELETE_SUCCESS});
            dispatch(actions.loadVimeoVideos());
        }).catch(res => {
            dispatch({ type: actionTypes.VIMEO_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
}; 

export const setCurrentVideo = (video) => {
    return dispatch => {
        dispatch({ type: actionTypes.VIMEO_SET_CURRENT_VIDEO, video: video});
    };
};

/*
export const setSearchDevices = (devices) => {
    return dispatch => {
        dispatch({ type: actionTypes.DEVICE_SET_SEARCH, devices: devices});
    };
};
*/
